<div class="main-container">

    <div class="left-container">

        <div class="content">

            <div class="logo-title">
                <img src="assets/img/logos uoetsylra/logo sindicato.png" alt="logo UOETSYLRA" class="logo">
                <h1>Bienvenido a beneficios UOETSYLRA</h1>
            </div>

            <p>Union Obreros y Empleados Tintoreros, Sombrereros y Lavaderos de la República Argentina.<br><strong>Aplicación oficial para acceder a sus beneficios, credenciales y realizar trámites sindicales.</strong></p>

            <button class="default-btn" routerLink="/profile-authentication" type="button" (click)="this.navigateRoot('/profile-authentication')">
                <i class="fas fa-user-circle"></i> Regístrese 
            </button>

            <app-appstore-badges></app-appstore-badges>

            <div style="margin-top: 15px; font-size: 14px; text-align: center; display: flex; gap: 20px; justify-content: center;">
                <a href="https://beneficios.uoetsylra.cipbyte.io/politica_de_privacidad/terminos-y-condiciones.html" target="_blank" class="link-footer">Términos y condiciones</a>
                <a href="https://beneficios.uoetsylra.cipbyte.io/politica_de_privacidad/politica_de_privacidad.html" target="_blank" class="link-footer">Política de privacidad</a>
            </div>

        </div>

    </div>
    
    <div class="right-container">
        <img src="assets/img/sliders/modern_login_bg.png" alt="image" class="slider-image">
    </div>

</div>
